namespace $ {
	$mol_test_mocks.push( $=> $.$mol_fail_log = ()=> false )
}

